import { getConciliationBalanceRows, getConciliationBalanceAmount, getRemovedConciliationAdjustment } from '../../../../../../utils/conciliationBalanceRows'
import ConciliationAdjustmentAmount from '../../../../../ui/ConciliationAdjustmentAmount'
import { getConciliationAdjustmentDisplay } from '../../../../../../utils/conciliationAdjustmentDisplay'
import { getConciliationAccountDisplayNumber } from '../../../../../../utils/conciliationAccountDisplay'
import { preferAdjustmentConciliationRows } from '../../../../../../utils/conciliationRows'
import { getVinculacionAvailableAmount, getVinculacionAppliedAmount, getVinculacionPendingAmount } from '../../../../../../utils/vinculacionAmounts'
import AssignedAmountInput from '../../../../../modalDialogEditarMovBancario/AssignedAmountInput'
import { buildBankConciliationPayload, routeEditedConciliationAmounts } from '../../../../../modalDialogEditarMovBancario/bankConciliationPayload'
import ListRemuneracion from './ListRemuneracion'
import ResizableModal from '../../../../../ui/ResizableModal'
import ConfirmConciliationModal from '../../../../../ui/ConfirmConciliationModal'
import { BankAPI } from '../../../../../../../api/bancos.api'
import { useContext, useEffect, useMemo, useState } from 'react'
import GlobalContext from '../../../../../../../context/global-context'
import LoaderMain from '../../../../../../../assets/svgIcons/loaderMain.json'
import Lottie from 'lottie-react'
import { Box } from '@mui/material'
import { formatCurrency, formatDate } from '../../../../../../utils/formatter'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import { bankIcons } from '../../../../../../modules/views/dashboard/Administracion/bancos/data'
import imgDefaultBank from '../../../../../../../assets/iconos/iconCasa.png'
import { Button } from '../../../../../ui'
import { normalizeConciliationPayload } from '../../../../../../utils/normalizeConciliationLinkage'
import { applyConciliationAdjustment } from '../../../../../../utils/conciliationAdjustment'
import { REACT_APP_RECONCILIATION_API_URL } from '../../../../../../utils/constant'

const ModalConciliacionRemuneracion = ({ open, setOpen, idLibro, tipoLibro,setSwitchGetData }) => {
  const { currentBusiness } = useContext(GlobalContext)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})
  const [reconciliationDetail, setReconciliationDetail] = useState(null)
  const [loadingReconciliationDetail, setLoadingReconciliationDetail] = useState(false)
  const [, setReconciliationDetailError] = useState(null)
  const [savingConciliation, setSavingConciliation] = useState(false)
  const bankAPI = new BankAPI()
  const organizationAPI = new OrganizationAPI()
  const [, setInitialSelectedIds] = useState([])
  const [selectedBank, setSelectedBank] = useState('')
  const [selectedDataByOrigen, setSelectedDataByOrigen] = useState({})
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({})
  const [selectedIds, setSelectedIds] = useState({
    banco: [],
    tc: [],
    caja: [],
    gestion: []
  })
  const [unselectedIds, setUnselectedIds] = useState({
    banco: [],
    tc: [],
    caja: [],
    gestion: []
  })
  const [useCajaPrincipal, setUseCajaPrincipal] = useState(false)
  const [origenSeleccionado, setOrigenSeleccionado] = useState([])
  const [showConfirmPopup, setShowConfirmPopup] = useState(false)
  const [popupMessage, setPopupMessage] = useState('')
  const [editedAmounts, setEditedAmounts] = useState({})
  useEffect(() => setEditedAmounts({}), [open, idLibro, tipoLibro])

  const modalIsLoading = loading || loadingReconciliationDetail || savingConciliation

  const getRowId = item => {
    if (!item) return undefined
    if (item.tipo === 'caja')
      return `custom-caja-${item.id || item.nombreCuentaBanco || 'principal'}`
    return (
      item?.idPrincipal ??
      item?.id_principal ??
      item?.egreso?.idPrincipal ??
      item?.ingreso?.idPrincipal ??
      item?.linkage?.idPrincipal ??
      item?.id
    )
  }

  const toNumId = rid => {
    const n = Number(rid)
    return Number.isFinite(n) ? n : null
  }
  
  const linkage = tipoLibro === 'previred' ? data?.linkagePrevired : data?.linkage
  const getMovementDate = item => {
    const linked = (linkage ?? []).find(row => String(getRowId(row)) === String(getRowId(item)))
    return linked ? linked.fechaRelacionada : item.fecha
  }

  const serverLinkedIdSet = useMemo(() => {
    const ids = (linkage ?? []).map(it => toNumId(getRowId(it))).filter(n => n !== null)
    return new Set(ids)
  }, [linkage])

  const isLinkedOnServerByRowId = rid => {
    const n = toNumId(rid)
    return n !== null && serverLinkedIdSet.has(n)
  }

  const getServerLinkedIds = item => {
    const comprobante = String(item?.comprobante ?? '').trim()
    const itemIds = [item?.id, item?.idPrincipal, getRowId(item)]
      .map(toNumId)
      .filter(id => id !== null)
    const linkedIds = (linkage ?? []).flatMap(linkedItem => {
      const linkedComprobante = String(linkedItem?.comprobante ?? '').trim()
      const serverIds = [linkedItem?.id, linkedItem?.idPrincipal, getRowId(linkedItem)]
        .map(toNumId)
        .filter(id => id !== null)
      const sameMovement =
        (comprobante && comprobante === linkedComprobante) ||
        itemIds.some(id => serverIds.includes(id))
      return sameMovement ? serverIds : []
    })
    return [...new Set([...itemIds, ...linkedIds])]
  }

  const getSelectionOrigin = item => {
    if (['banco', 'caja'].includes(item?._origen)) return item._origen
    const isCajaPrincipal = [item?.nombreCuentaBanco, item?.nombreBanco, item?.name]
      .some(value => String(value ?? '').trim().toLowerCase() === 'caja principal')
    if (isCajaPrincipal) return 'caja'
    if ([item?.tabla, item?.tablaPrincipal].some(value => [6, 7].includes(Number(value)))) {
      return 'banco'
    }
    return ['banco', 'caja'].includes(item?.tipo) ? item.tipo : origenSeleccionado[0] || 'banco'
  }

   const firstValid = (...values) =>
    values.find(v => v != null && Number(v) !== 0) ?? 0

  const getMontoBase = (r, tipoLibroActual) => {
    if (tipoLibroActual === 'liquido') {
      return r.montoTotal ?? 0
    }
    return r.montoNeto ?? 0
  }

const selectedRowsData = useMemo(() => {
  return Object.entries(selectedDataByOrigen).flatMap(([origen, rows]) =>
    (rows ?? []).map(r => ({
      ...r,
      _origen: origen,
      montoEditable:
        r.nombreCuenta === 'Boletas de Honorarios'
          ? r.montoNetoLiquido ?? 0
          : firstValid(
              r.montoEditable,
              r.montoRelacionado,
              r.montoAbono,
              r.montoCargo,
              getMontoBase(r, tipoLibro),
              r.montoTotal
            )
    }))
  )
}, [selectedDataByOrigen, tipoLibro])

  const toNumericOrNull = value => {
    const num = Number(value)
    return Number.isFinite(num) ? num : null
  }

  const getBancoAmount = item => {
    if (item?.nombreCuenta === 'Boletas de Honorarios') {
      const neto = toNumericOrNull(item?.montoNetoLiquido)
      if (neto !== null) return neto
    }

    const candidates = [
      item?.montoCargo,
      item?.haber,
      item?.montoAbono,
      item?.debe,
      item?.montoTotal,
      item?.montoRelacionado,
      item?.montoNeto,
      item?.amount
    ]

    for (const candidate of candidates) {
      const num = toNumericOrNull(candidate)
      if (num !== null && num !== 0) return num
    }

    const fallback = toNumericOrNull(
      item?.montoRelacionado ?? item?.montoTotal ?? item?.montoEditable ?? item?.amount ?? item?.montoNeto ?? 0
    )
    return fallback ?? 0
  }

  const getItemAmountForSum = item => {
  if (editedAmounts[getRowId(item)] != null) return editedAmounts[getRowId(item)]
  if (!item?.customRow && item?.tipo !== 'caja' && item?._origen !== 'caja') {
    const linked = (linkage ?? []).find(row => String(getRowId(row)) === String(getRowId(item)))
    return linked ? getConciliationBalanceAmount(linked, linkage ?? []) : getVinculacionAvailableAmount(item)
  }
  const base = getMontoBase(item, tipoLibro) // 👈 agregado
  if (item?.montoEditable != null) {
    return Math.abs(Number(item.montoEditable) || 0)
  }

  const isCajaOGestion =
    item?.tipo === 'caja' ||
    item?.nombreCuentaBanco?.toLowerCase?.().includes('caja')

  if (isCajaOGestion) {
    return Math.abs(
      item?.montoRelacionado ??
        item?.montoAbono ??
        item?.montoCargo ??
        base ??
        item?.amount ??
        0
    )
  }
  return getBancoAmount(item)
}


  const hasSelectedOrigen = useMemo(
    () => Object.values(selectedDataByOrigen || {}).some(rows => (rows?.length ?? 0) > 0),
    [selectedDataByOrigen]
  )

  const rowsBase = useMemo(() => {
    const selectedRows = hasSelectedOrigen
      ? selectedRowsData
      : []

    const linkedRows = Array.isArray(linkage)
      ? linkage
      : []

    const mergedRows = []
    const seenIds = new Set()

    ;preferAdjustmentConciliationRows([...selectedRows, ...linkedRows]).forEach(item => {
      const rowId = getRowId(item)
      const key = rowId != null ? String(rowId) : null

      if (key && seenIds.has(key)) return

      if (key) {
        seenIds.add(key)
      }

      mergedRows.push(item)
    })

    return mergedRows
  }, [hasSelectedOrigen, selectedRowsData, linkage])

  const rowsToShow = useMemo(() => {
    const allUnselected = Object.values(unselectedIds || {}).flat()
    return rowsBase.filter(it => {
      const n = toNumId(getRowId(it))
      return !(n !== null && allUnselected.includes(n))
    })
  }, [rowsBase, unselectedIds])

  const totalDocumento = Math.abs(Number(getMontoBase(data, tipoLibro)) || 0)
  const totalAplicado = rowsToShow.reduce((sum, item) => sum + getItemAmountForSum(item), 0)
  // El auxiliar general no distingue las obligaciones de líquido y Previred.
  // Total y pagos deben pertenecer al mismo tipo de libro seleccionado.
  const totalVinculado = getConciliationBalanceRows(linkage ?? [])
    .reduce((sum, item) => sum + getVinculacionAppliedAmount(item), 0)
  const statusLibro = String(tipoLibro === 'previred' ? data.statusPrevired : data.status)
    .trim().toUpperCase()
  const saldoInicial = statusLibro === 'PAGADO' ? 0 : totalDocumento - totalVinculado
  const saldoRestante = getVinculacionPendingAmount(
    saldoInicial, totalDocumento, totalVinculado, totalAplicado
  ) + (statusLibro === 'PAGADO'
    ? getRemovedConciliationAdjustment(linkage ?? [], rowsToShow, totalDocumento) : 0)

  useEffect(() => {
    const nextMap = {}
    Object.values(selectedDataByOrigen || {})
      .flat()
      .forEach(item => {
        const primaryKey = item?.id != null ? String(item.id) : null
        const secondaryKey = getRowId(item)
        if (primaryKey) {
          nextMap[primaryKey] = true
        }
        if (secondaryKey != null) {
          nextMap[String(secondaryKey)] = true
        }
      })
    setSelectedCheckboxes(nextMap)
  }, [selectedDataByOrigen])

  const handleCurrentData = origen => rows => {
    setSelectedDataByOrigen(prev => ({
      ...prev,
      [origen]: rows
    }))
  }

  const setDataAndLinkedSelection = rawPayload => {
    const normalized = normalizeConciliationPayload(rawPayload)
    const linkedRows =
      tipoLibro === 'previred' ? normalized?.linkagePrevired : normalized?.linkage
    const rows = Array.isArray(linkedRows) ? linkedRows : []
    const isCajaPrincipal = item =>
      [item?.nombreCuentaBanco, item?.nombreBanco, item?.name]
        .some(value => String(value ?? '').trim().toLowerCase() === 'caja principal')

    const banco = rows
      .filter(item => !isCajaPrincipal(item))
      .map(item => ({ ...item, _origen: 'banco' }))
    const caja = rows
      .filter(isCajaPrincipal)
      .map(item => ({ ...item, _origen: 'caja' }))
    const selectionByOrigin = {
      ...(banco.length > 0 ? { banco } : {}),
      ...(caja.length > 0 ? { caja } : {})
    }
    const idsByOrigin = {
      banco: banco.map(getRowId).filter(id => id != null),
      caja: caja.map(getRowId).filter(id => id != null),
      tc: [],
      gestion: []
    }
    const checked = rows.reduce((acc, item) => {
      const id = getRowId(item)
      if (id != null) acc[String(id)] = true
      return acc
    }, {})

    setData(normalized)
    setSelectedDataByOrigen(selectionByOrigin)
    setSelectedIds(idsByOrigin)
    setSelectedCheckboxes(checked)
    setUnselectedIds({ banco: [], tc: [], caja: [], gestion: [] })
  }

  const handleClose = () => { setOpen(false) }

  const getData = async () => {
    try {
      setLoading(true)
      const response = await bankAPI.getDataLibros(currentBusiness?.id, idLibro)
      setDataAndLinkedSelection(response.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const getReconciliationDetail = async () => {
    if (
      !currentBusiness?.id ||
      !idLibro
    ) {
      setReconciliationDetail(null)
      setReconciliationDetailError(null)
      setLoadingReconciliationDetail(false)
      return
    }

    const params = new URLSearchParams({
      businessId: String(currentBusiness.id),
      idLibro: String(idLibro)
    })

    try {
      setLoadingReconciliationDetail(true)
      setReconciliationDetailError(null)
      setReconciliationDetail(null)

      const response = await fetch(
        `${REACT_APP_RECONCILIATION_API_URL}/remuneraciones/conciliacion/movimientos?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        }
      )

      if (!response.ok) {
        throw new Error(
          `Error consultando detalle de conciliación: ${response.status}`
        )
      }

      const responseData = await response.json()
      setReconciliationDetail(responseData)
    } catch (error) {
      console.error(
        'No fue posible obtener el detalle de conciliación:',
        error
      )

      setReconciliationDetail(null)
      setReconciliationDetailError(
        'No fue posible cargar el detalle de la conciliación.'
      )
    } finally {
      setLoadingReconciliationDetail(false)
    }
  }

    const saveReconciliationReview = async ({
      engineIdLibros,
      effectiveIdLibros
    }) => {
      if (
        !currentBusiness?.id ||
        !reconciliationDetail?.period ||
        !tipoLibro
      ) {
        return
      }

      const response = await fetch(
        `${REACT_APP_RECONCILIATION_API_URL}/remuneraciones/conciliacion/review`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            businessId: Number(currentBusiness.id),
            period: reconciliationDetail.period,
            category: tipoLibro,
            engineIdLibros,
            effectiveIdLibros,
            metadata: {
              executionSource: 'frontend_luca',
              action: 'guardar_conciliacion'
            }
          })
        }
      )

      if (!response.ok) {
        throw new Error(
          `Error persistiendo revisión de conciliación: ${response.status}`
        )
      }

      return response.json()
    }

  useEffect(() => {
    if (!open || !currentBusiness?.id || !idLibro) return

    getData()
    getReconciliationDetail()
  }, [
    open,
    currentBusiness?.id,
    idLibro
  ])

  const handleDesvincular = async ids => {
    if (ids.length === 0) return
    const payload = { ids: ids.map(Number) }
    try {
      await organizationAPI.postDesvincular(
        {
          businessId: currentBusiness.id,
          idLibro: tipoLibro === 'liquido' ? data.idLiquido : data.idPrevired
        },
        payload
      )
    } catch (error) {
      console.error(error)
      throw error
    } 
  }

  const soloDesvinculacion =
    [...(unselectedIds.banco ?? []), ...(unselectedIds.caja ?? [])].length > 0 &&
    Object.values(selectedDataByOrigen).flat().every(item => {
      const persisted = (linkage ?? []).find(linked => String(getRowId(linked)) === String(getRowId(item)))
      return persisted && editedAmounts[getRowId(item)] == null && (item.montoEditable == null ||
        getItemAmountForSum(item) === getItemAmountForSum(persisted))
    })

 const handleSubmit = async (ajuste = false) => {
  try {
    setSavingConciliation(true)

      // --- Snapshot E2E antes de modificar Luca ---
      const engineIdLibros = [
        ...new Set(
          (reconciliationDetail?.movements ?? [])
            .map(item => toNumId(item?.idLibro))
            .filter(id => id !== null)
        )
      ]

      const effectiveIdLibros = [
        ...new Set(
          (rowsToShow ?? [])
            .map(item => toNumId(getRowId(item)))
            .filter(id => id !== null)
        )
      ]

      // --- 1. Detectar elementos para desvincular ---
      const bancoUnselected = unselectedIds.banco?.length ?? 0;
      const cajaUnselected = unselectedIds.caja?.length ?? 0;
      const idsParaDesvincular = [
        ...(unselectedIds.banco ?? []),
        ...(unselectedIds.caja ?? [])
      ].filter((id, index, ids) => ids.indexOf(id) === index)

      if (idsParaDesvincular.length > 0) {
        await handleDesvincular(idsParaDesvincular);
      }

      // --- 2. Detectar elementos para vincular ---
      const hayAlgoParaVincular =
        (selectedDataByOrigen['banco']?.length ?? 0) > 0 ||
        (selectedDataByOrigen['caja']?.length ?? 0) > 0;

      // Si solo se desvinculó y no hay nada nuevo para vincular, recargar y cerrar
      if (soloDesvinculacion || ((bancoUnselected > 0 || cajaUnselected > 0) && !hayAlgoParaVincular)) {
        await saveReconciliationReview({
          engineIdLibros,
          effectiveIdLibros
        })

        setSwitchGetData(true);
        handleClose();
        return;
      }

      // --- 3. Preparar DTO completo ---
      const dto = {
        datoBanco: { ids: [] },
        datoBoleta: { ids: [] },
        datoCaja: {},
        datoCajaLastYear: {},
        instrucciones: []
      };

      let bancoFlag = false;
      let cajaFlag = false;
      let gestionFlag = false; // siempre false
      let boletaFlag = false;  // siempre false

      // Con ajuste, incluir también los movimientos vinculados que siguen seleccionados.
      const generaAjuste = [245, 326].includes(Number(ajuste))
      const idsBanco = (selectedDataByOrigen['banco'] ?? [])
        .filter(item => {
          const rowId = getRowId(item)
          return generaAjuste || !isLinkedOnServerByRowId(rowId) || editedAmounts[rowId] != null
        })
        .map(item => getRowId(item))
        .filter(id => id != null)

      if (idsBanco.length > 0) {
        const routed = routeEditedConciliationAmounts(buildBankConciliationPayload(
          idsBanco.map(Number),
          (selectedDataByOrigen.banco ?? []).filter(item => idsBanco.includes(getRowId(item)))
            .map(item => ({ ...item, id: getRowId(item), idPrincipal: getRowId(item) })),
          editedAmounts
        ), { ids: [] })
        dto.datoBanco = routed.datoBanco
        dto.datoBoleta = routed.datoBoleta
        bancoFlag = routed.instrucciones[0]
        boletaFlag = routed.instrucciones[1]
      }

      const calcularMontoCaja = (rows) =>
      rows.reduce(
        (acc, item) => acc + (item.montoEditable ?? item.montoTotal ?? 0),
        0
      );

      const rowsCaja = selectedDataByOrigen['caja'] ?? [];
      if (rowsCaja.length > 0) {
        dto.datoCaja = { monto: calcularMontoCaja(rowsCaja) };
        cajaFlag = true;
      }

      // --- 4. Instrucciones ---
      dto.instrucciones = [bancoFlag, boletaFlag, cajaFlag, gestionFlag];

      // --- 5. Enviar a la API ---
      await organizationAPI.postForInOne(
        {
          businessId: Number(currentBusiness.id),
          idLibro: Number(idLibro)
        },
        applyConciliationAdjustment(dto, ajuste)
      );

      // --- 6. Persistir revisión humana E2E ---
      await saveReconciliationReview({
        engineIdLibros,
        effectiveIdLibros
      })

      // --- 7. Refrescar y cerrar ---
      setSwitchGetData(true);
      handleClose();
    } catch (error) {
      console.error('Error en la conciliación:', error);
    } finally {
      setSavingConciliation(false)
    }
  };

  return (
    <ResizableModal
      open={open}
      onClose={handleClose}
      size="large" 
      footer={
        <>
          <Button
            onClick={handleClose}
            className='text-[10px] bg-primary text-white rounded-full '
            title='Cerrar'
          />
          <Button
            className='text-[10px] bg-accent2 text-white rounded-full'
            title='Guardar Conciliación'
           onClick={() => {
              if (soloDesvinculacion) {
                handleSubmit()
                return
              }
              const montoPorSaldar = Number(saldoRestante.toFixed(2))
              if (montoPorSaldar > 0) {
                setPopupMessage( 'El monto conciliado es inferior al saldo pendiente. Revisa si faltan transacciones por incluir.' )
                setShowConfirmPopup(true)
              } else if (montoPorSaldar < 0) {
                setPopupMessage( 'El monto conciliado supera el saldo pendiente. Verifica los valores antes de continuar.' )
                setShowConfirmPopup(true)
              } else {
                handleSubmit()
              }
            }}
          />
        </>
        }
      >
      <>
        {modalIsLoading ? (
          <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
            <Lottie animationData={LoaderMain} loop autoplay style={{ width: 100, height: 100 }} />
          </Box>
          ) : (
          <>
            <div className='flex w-full h-full gap-4'>
              <div className="flex-1 h-full w-[65%]">
                <ListRemuneracion
                  idLibro={idLibro}
                  setInitialSelectedIds={setInitialSelectedIds}
                  dataModal={data}
                  unselectedIds={unselectedIds}
                  setUnselectedIds={setUnselectedIds}
                  onCurrentDataBanco={handleCurrentData('banco')}
                  onCurrentDataCaja={handleCurrentData('caja')}
                  selectedBank={selectedBank}
                  setSelectedBank={setSelectedBank}
                  selectedIds={selectedIds}
                  setSelectedIds={setSelectedIds}
                  useCajaPrincipal={useCajaPrincipal}
                  setUseCajaPrincipal={setUseCajaPrincipal}
                  origenSeleccionado={origenSeleccionado}
                  setOrigenSeleccionado={setOrigenSeleccionado}
                  selectedCheckboxes={selectedCheckboxes}
                  setSelectedCheckboxes={setSelectedCheckboxes}
                  selectedDataByOrigen={selectedDataByOrigen}
                  setSelectedDataByOrigen={setSelectedDataByOrigen}
                  getRowId={getRowId}
                  dataLinkage={data.linkage}
                  dataLinkagePre={data.linkagePrevired}
                  tipoLibro={tipoLibro}
                  reconciliationDetail={reconciliationDetail}
                  setSwitchGetData={setSwitchGetData}
                />
              </div>
              <div className='flex flex-col w-[35%] h-full font-sans font-medium'>
                <div className='flex-1 flex flex-col bg-white rounded-3xl shadow-lg p-2 text-[11px] overflow-auto'>
                  <div className='flex justify-between items-start mb-1 border-b pb-1'>
                    {/* Bloque izquierdo: documento + folio + fecha */}
                    <div className='flex gap-2'>
                      <div className='flex flex-col'>
                        <p className='text-[10px] font-bold uppercase leading-5'>
                          {tipoLibro === 'liquido' ? 'REMUNERACIONES' : 'PREVIRED'}
                        </p>
                        <div className='flex items-center gap-1 text-[11px] leading-tight'>
                          <span>{data.rut}</span>
                        </div>
                      </div>
                    </div>

                    <div className='flex flex-col items-end text-right text-[10px] min-w-[110px] whitespace-nowrap '>
                      {tipoLibro === 'liquido' ? (
                        <>
                          <span
                            className={
                              reconciliationDetail?.isReconciled
                                ? 'text-accent2'
                                : 'text-accent3'
                            }
                          >
                            {reconciliationDetail?.status || data.status}
                          </span>
                          <p className='text-[11px] font-semibold leading-tight'>
                            Sueldo Líquido: {formatCurrency(data.montoTotal)}
                          </p>
                        </>
                      ) : (
                        <>
                          <span
                            className={
                              reconciliationDetail?.isReconciled
                                ? 'text-accent2'
                                : 'text-accent3'
                            }
                          >
                            {reconciliationDetail?.status || data.statusPrevired}
                          </span>
                          <p className='text-[11px] font-semibold leading-tight'>
                            Previred: {formatCurrency(data.montoNeto)}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                  {/* Filas de linkage/selectedRows */}
                  <div className='flex-1 overflow-auto font-sans font-medium'>
                    {rowsToShow.map(
                      (item, idx) => (
                        <div
                          key={idx}
                          className='flex justify-between items-center text-gray-700 py-1 border-b last:border-0'
                        >
                          {/* LADO IZQUIERDO */}
                          <div className='flex items-center gap-4'>
                            <input
                            type='checkbox'
                            className='rounded'
                            checked={(() => {
                              const rowId = getRowId(item)
                              const isUnselected = Object.values(unselectedIds || {})
                                .flat()
                                .some(id => String(id) === String(rowId))
                              return (
                                !isUnselected &&
                                (selectedCheckboxes[String(rowId)] === true ||
                                  isLinkedOnServerByRowId(rowId))
                              )
                            })()}
                            onChange={e => {
                              const checked = e.target.checked
                              const rowId = getRowId(item)
                              const rowOrigen = getSelectionOrigin(item)

                              // 1) Actualiza selección por origen (add/remove)
                              setSelectedDataByOrigen(prev => {
                                const next = { ...prev }
                                if (checked) {
                                  const arr = next[rowOrigen] || []
                                  if (!arr.some(r => getRowId(r) === rowId)) {
                                    next[rowOrigen] = [...arr, { ...item, _origen: rowOrigen }]
                                  }
                                } else {
                                  for (const k of Object.keys(next)) {
                                    next[k] = (next[k] || []).filter(r => getRowId(r) !== rowId)
                                  }
                                }
                                return next
                              })

                              // 2) Actualiza selectedIds por origen
                              setSelectedIds(prev => {
                                const arr = prev[rowOrigen] || []
                                return {
                                  ...prev,
                                  [rowOrigen]: checked
                                    ? [...arr, rowId]
                                    : arr.filter(id => id !== rowId)
                                }
                              })

                              // 3) Estado de los checkboxes
                              setSelectedCheckboxes(prev => ({
                                ...prev,
                                [rowId]: checked
                              }))

                              // 4) Mantener unselectedIds por origen
                              setUnselectedIds(prev => {
                                const linkedIds = getServerLinkedIds(item)
                                if (linkedIds.length === 0) return prev
                                const arr = prev[rowOrigen] || []
                                return {
                                  ...prev,
                                  [rowOrigen]: checked
                                    ? arr.filter(id => !linkedIds.includes(Number(id)))
                                    : [...new Set([...arr, ...linkedIds])]
                                }
                              })
                            }}
                          />
                            {item.nombreFolio ? (
                              ''
                            ) : (
                              item.nombreCuentaBanco && (
                                <img
                                  src={bankIcons[item.nombreCuentaBanco] || imgDefaultBank}
                                  alt={item.nombreCuentaBanco}
                                  className='w-8 h-8'
                                />
                              )
                            )}

                            <div className='flex flex-col leading-tight'>
                              <span>
                                {item.nombreCuentaBanco}
                              </span>
                              <span>
                                {getConciliationAccountDisplayNumber(item, item.numeroCuentaBanco || item.numeroFolio)}
                              </span>
                            </div>
                            <span>{item.descripcion || item.razonSocial || item.glosa}</span>
                            <span>{formatDate(getMovementDate(item))}</span>
                          </div>
                          <div className='flex items-center'>
                          {(() => {
                            if (getConciliationAdjustmentDisplay(item)) return <ConciliationAdjustmentAmount movement={item} documentTotal={totalDocumento} formatCurrency={formatCurrency} />
                            const isCajaItem =
                              item?._origen === 'caja' ||
                              item?.tipo === 'caja' ||
                              item?.nombreCuentaBanco?.toLowerCase?.().includes('caja')
                            const isGestionItem =
                              item?._origen === 'gestion' ||
                              item?.customRow === true ||
                              item?.tipo === 'gestion'

                            if (!isCajaItem && !isGestionItem) {
                              const linked = (linkage ?? []).find(row => String(getRowId(row)) === String(getRowId(item)))
                              const baseline = linked ? getVinculacionAppliedAmount(linked) : getVinculacionAvailableAmount(item)
                              return (
                                <div className='flex flex-col text-right gap-1'>
                                  <span className='text-gray-400'>Disponible Asignado</span>
                                  <AssignedAmountInput
                                    aria-label={`Monto seleccionado ${getRowId(item)}`}
                                    className='border rounded-full text-xs text-right px-2 py-1 w-28 self-end'
                                    value={editedAmounts[getRowId(item)] ?? baseline}
                                    min={1}
                                    max={getVinculacionAvailableAmount(item)}
                                    disabled={modalIsLoading}
                                    onCommit={value => {
                                      const amount = Number(value)
                                      if (amount <= 0 || amount > getVinculacionAvailableAmount(item)) return
                                      setEditedAmounts(previous => {
                                        const next = { ...previous }
                                        if (amount === baseline) delete next[getRowId(item)]
                                        else next[getRowId(item)] = amount
                                        return next
                                      })
                                      setSelectedDataByOrigen(previous => {
                                        const rows = previous.banco ?? []
                                        return rows.some(row => String(getRowId(row)) === String(getRowId(item)))
                                          ? previous : { ...previous, banco: [...rows, item] }
                                      })
                                    }}
                                  />
                                </div>
                              )
                            }

                            const origen =
                              item._origen || (isCajaItem ? 'caja' : isGestionItem ? 'gestion' : null)
                            const rowId = getRowId(item)
                            const currentRows = selectedDataByOrigen[origen] || []
                            const selectedItem = currentRows.find(r => getRowId(r) === rowId)
                            const isEditableMonto =
                              (selectedItem?.customRow ?? item?.customRow) === true

                            if (!isEditableMonto) {
                              const montoDisplay = Math.abs(
                                selectedItem?.montoEditable ??
                                  item?.montoEditable ??
                                  item?.montoAbono ??
                                  item?.montoCargo ??
                                  item?.montoRelacionado ??
                                  item?.montoTotal ??
                                  item?.amount ??
                                  item.montoNeto ??
                                  0
                              )
                              return (
                                <span className='text-right w-20'>
                                  {formatCurrency(montoDisplay)}
                                </span>
                              )
                            }

                            const montoValueRaw =
                              selectedItem?.montoEditable ??
                              item?.montoEditable ??
                              item?.montoAbono ??
                              item?.montoCargo ??
                              item?.montoTotal ??
                              item?.amount ??
                              item?.montoNeto ??
                              0
                            const montoValue = Math.abs(montoValueRaw)

                            return (
                              <input
                                key={`${origen}-${rowId}`}
                                type='text'
                                inputMode='numeric'
                                className='border rounded-full text-xs text-right px-1 py-0.5 w-20
                                  [appearance:textfield]
                                  [&::-webkit-outer-spin-button]:appearance-none
                                  [&::-webkit-inner-spin-button]:appearance-none'
                                value={`$ ${Number(montoValue).toLocaleString('es-CL')}`}
                                onFocus={e => {
                                  e.target.value = montoValue.toString()
                                }}
                                onBlur={e => {
                                  const raw = e.target.value.replace(/[^\d]/g, '')
                                  e.target.value = `$ ${Number(raw || 0).toLocaleString('es-CL')}`
                                }}
                                onChange={e => {
                                  const digits = e.target.value.replace(/[^\d]/g, '')
                                  const newValue = Number(digits || 0)
                                  setSelectedDataByOrigen(prev => {
                                    const clonedPrev = structuredClone(prev)
                                    const current = clonedPrev[origen] || []
                                    const updated = current.map(r =>
                                      getRowId(r) === rowId ? { ...r, montoEditable: newValue } : r
                                    )
                                    return { ...clonedPrev, [origen]: updated }
                                  })
                                }}
                              />
                            )
                          })()}
                        </div>
                        </div>
                      ))}
                  </div>
                   <div className='border-t border-gray-200 mt-2 pt-3 shrink-0'>
                      <div className='flex justify-between text-sm font-semibold text-[#000231]'>
                        <span>Monto Saldado</span>
                        <span>
                          {' '}
                          {formatCurrency(
                            Math.max(totalDocumento - Math.max(saldoRestante, 0), 0)
                          )}
                        </span>
                      </div>
                      <div className='flex justify-between text-sm font-semibold text-accent2 mt-1'>
                        <span>Diferencia</span>
                        <span>
                          {' '}
                          {formatCurrency(
                            saldoRestante
                          )}
                        </span>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
      <ConfirmConciliationModal
        difference={Number(saldoRestante.toFixed(2))}
        onGenerateAdjustment={ajuste => {
          setShowConfirmPopup(false)
          handleSubmit(ajuste)
        }}
        open={showConfirmPopup}
        message={popupMessage}
        onClose={() => setShowConfirmPopup(false)}
        actions={[
          { id: 'back', title: 'Volver', onClick: () => setShowConfirmPopup(false) },
          {
            id: 'save',
            title: 'Guardar',
            className: 'rounded-full bg-accent2 px-5 text-sm text-white',
            onClick: () => {
              setShowConfirmPopup(false)
              handleSubmit()
            }
          }
        ]}
      />
    </ResizableModal>
  )
}

export default ModalConciliacionRemuneracion
